export enum TravelXFeatureFlags {
    InAppNotificationsTickets = 'IN_APP_NOTIFICATIONS_TICKETS',
    NovaVMSAccountManagerLiveListChanges = 'nova-vms-amlivelist-changes',
    NovaVMSAccountManagerDealsChanges = 'nova-vms-amdeals-changes',
    ConnectVMSRecruiterSpecificOfferNotes = 'connect-vms-recruiter-specific-offer-notes',
    CertificationManagementAndMapping = 'certification-management-and-mapping',
    StateLicenseForClinicalTrackConfig = 'state-license-for-clinical-track-config',
    NovaJobDetailsStateLicenseFormField = 'nova-job-details-state-license-form-field',
    ClinicalReviewLowMissingSkillsCertsNotes = 'nova-clinical-review-low-missing-skills-certs-notes',
    NovaStateLicenseInMatchBreakdown = 'nova-state-license-in-match-breakdown',
    AltCertsMatchBreakdown = 'alt-certs-match-breakdown',
    NovaStateLicenseRecruiterNotes = 'nova-state-license-recruiter-notes',
    ShowPreviousChargeExpOnlyForRN = 'show-previous-charge-exp-only-for-rn',
    JobReqsAlternativeCertifications = 'job-reqs-alternative-certifications',
    AltCertsJobDetailsCompToggle = 'alt-certs-job-details-comp-toggle'
}
